// sdk-config.js
import BiuwerSDK  from 'biuwer-sdk';


// El API Key de tu CUENTA de Biuwer.
const apiKey = 'f36fb540-4132-11f0-ae9d-0d9155305dbc'; // Guardar de forma segura

// Si el uso del SDK se utiliza solamente para incrustar / embeber no es necesario el parámetro apiKey ya que no se realizan llamadas al API.
const sdk = new BiuwerSDK(apiKey);

export { sdk };